import url from './url'
import baseUrl from "./baseurl"
const AppConsts= {
    userManagement:{
        defaultAdminUserName: 'admin'
    },
    localization:{
        defaultLocalizationSourceName: 'Golf'
    },
    authorization:{
        encrptedAuthTokenName: 'enc_auth_token'
    },
    appBaseUrl: url,
    remoteServiceBaseUrl:"https://oss.golfreservations.club/",
    excelDownloadUrl: "https://golfreservations.club/" ,
    h5PayUrl:'https://mb.golfreservations.club/pagesB/order/order-detail?id=',
    paymethodList : ["球场现付","全额预付","部分预付"]
}
export default AppConsts